import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rer5bw4qz: FaireProductEntity = {
  token: "p_7rer5bw4qz",
  type: "product",
  name: "Open bracelet with charms, cubic zirconia, 18K PVD stainless steel, waterproof",
  brandToken: "b_3t5pew5dxb",
  brandName: "Minimalistajoyeria",
  imageUrl:
    "https://cdn.faire.com/fastly/f35e69ca0d804d1a6bd927eb1fe3d2a2eb81cba387431a19d7d3154fd138a847.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d11b31a21cadc70561c6828711f38af91e153825de9dd5a63e35309ac38dcc1.jpeg",
    "https://cdn.faire.com/fastly/f7e79718bf9eae483d86774fd8a36327d05d4a0e7c0bb570ec7aae34811bc300.jpeg",
    "https://cdn.faire.com/fastly/abfabccc98213243e856f9f021e64190d375496b80465fdd501aed34fc1cdc4a.jpeg",
  ],
  priceDollars: 11.02,
  description:
    'Premium quality stainless steel\n\nBase material: stainless steel\nFinish: 18k PVD gold plating (waterproof) gives it a rich, shiny, and luxurious golden finish.\nDurability: Unlike other materials, the combination of stainless steel and quality PVD plating can maintain its appearance for a long time.\nIt is water- and sweat-resistant.\nOne-size open "cuff" with cubic zirconia and a vintage touch.\nStyle: modern and luxurious yet elegant\n\nStock in Spain: Fast shipping and no customs.\n\nDirect price: Luxury aesthetics at factory price.',
  tags: [],
  msrpDollars: 44.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:40.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
